import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

interface IProps {
    value1: string;
    value2: string;
    value3: string;
    value4: string;
    labelColor?: {
        color: string;
        background: string;
    };
}

const TransactionItemCardV2: React.FC<IProps> = (props) => {
    const { value1, value2, value3, value4, labelColor } = props;
    return (
        <Styles.Wrapper>
            <Styles.DivFlex>
                <Styles.RowFlex>
                    <Styles.Value1>{value1}</Styles.Value1>
                    <Styles.Value2 label={labelColor}>{value2}</Styles.Value2>
                </Styles.RowFlex>
                <Styles.RowFlex>
                    <Styles.Value3>{value3}</Styles.Value3>
                    <Styles.Value4>
                        {labelColor?.background ? (
                            <Styles.Value4BackgroundText
                                background={labelColor.background}
                                color={labelColor.color}
                            >
                                {value4}
                            </Styles.Value4BackgroundText>
                        ) : (
                            value4
                        )}
                    </Styles.Value4>
                </Styles.RowFlex>
            </Styles.DivFlex>
            <Styles.RightArrowIconFlex>
                <Image
                    width={'12px'}
                    height={'12px'}
                    alt={''}
                    src={getImageBasePath('/icons/rightArrow.svg')}
                />
            </Styles.RightArrowIconFlex>
        </Styles.Wrapper>
    );
};

export default TransactionItemCardV2;
